import React, {
	memo,
	useCallback,
	useEffect,
	useState
} from 'react';
import {
	Loader,
	Segment
} from 'semantic-ui-react';

import {
	handleError,
	log
} from '../../../services/utils';

import { getStackedVisual } from '../../../api/nora/visual';

import { useUIAction } from '../../../contexts/UIContext';

import StackedBar from './charts/StackedBar';

const StackedBarChart = () => {
	const { setApiErrorAlert } = useUIAction();

	const [ isLoading, setIsLoading ] = useState( true );
	const [ data, setData ] = useState( null );
	const [ description, setDescription ] = useState( null );
	const [ label, setLabel ] = useState( null );

	const retrieveCharts = useCallback( async () => {
		try {
			const chartData = await getStackedVisual( 83 );

			const labels = chartData?.results[ 0 ].values[ 0 ].values.map( ( { label } ) => label );

			const datasets = chartData
				?.results[ 0 ]
				.values.map( ( {
					backColor,
					label,
					values
				} ) => {
					const data = values.map( ( { val } ) => val );

					return {
						backgroundColor: backColor,
						data,
						label
					};
				} );

			setData( {
				labels,
				datasets
			} );
			setDescription( chartData.description );
			setLabel( chartData.name );
		} catch ( error ) {
			setApiErrorAlert( error );
			throw error;
		}
	}, [ setApiErrorAlert ] );

	useEffect( () => {
		( async () => {
			try {
				await retrieveCharts();
				setIsLoading( false );
			} catch ( error ) {
				if ( error.message !== 'canceled' ) {
					handleError( error );
				}
			}
		} )();
	}, [ retrieveCharts ] );

	return (
		<>
			{ log( 'stackedBarChart' ) }
			<Segment
				style={ {
					alignItems: 'center',
					display: 'flex',
					flex: 1,
					flexDirection: 'column',
					margin: '2rem 0 2rem 2rem',
					minHeight: '343px',
					minWidth: '300px'
				} }
			>
				{ isLoading
					? <Loader
						active
						content="Retrieving chart data..."
					/>
					: <StackedBar
						data={ data }
						description={ description }
						label={ label }
					/>
				}
			</Segment>
		</>
	);
};

export default memo( StackedBarChart );
